import { BoxesIcon, DrillIcon, FanIcon, Grid3x3Icon, HardHatIcon, TowerControlIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Underground Mine Fundamentals: Ore Bodies, Mine Layout, Access & Development',
    summary: 'A visual technical reference to how an underground mine is laid out, accessed and developed, from the orebody to shafts, declines and levels.',
    icon: TowerControlIcon,
  },
  {
    number: '02',
    title: 'Underground Mining Methods: Room & Pillar, Stoping, Cut & Fill & Caving',
    summary: 'A visual technical reference to every major underground method, how it is selected and how stopes are mined, filled and sequenced.',
    icon: BoxesIcon,
  },
  {
    number: '03',
    title: 'Rock Mechanics & Ground Support: Geomechanics for Underground Mines',
    summary: 'A visual technical reference to how rock behaves around openings and how bolts, mesh, shotcrete and cables keep it in place.',
    icon: Grid3x3Icon,
  },
  {
    number: '04',
    title: 'Drilling, Blasting & the Development Cycle',
    summary: 'A visual technical reference to the development cycle, drill patterns, explosives concepts, controlled blasting and safe re-entry.',
    icon: DrillIcon,
  },
  {
    number: '05',
    title: 'Ventilation, Drainage & Mine Services',
    summary: 'A visual technical reference to mine air, gases, fans and ducting, dewatering and the services that keep a mine running.',
    icon: FanIcon,
  },
  {
    number: '06',
    title: 'Loading, Haulage, Hoisting & Underground Safety Operations',
    summary: 'A visual technical reference to moving ore from the draw point to the surface and to the daily safety systems underground.',
    icon: HardHatIcon,
  },
];
